import React, { useEffect, useState } from "react";
import { Col, Form, Input, InputNumber, Row, Statistic } from "antd";
import Styles from "./Styles";
import SectionTitleArea from "../../components/moleculas/SectionTitleArea";
import { apiGetPath } from "../../api/api";
import moment from "moment";

const requredRlues = { required: true, message: "필수입력입니다." };

/* 한 Row에 2컬럼인 폼의 컬럼분할 비율 */
const responsiveColOption = {
  sm: 24,
  md: 11,
};

function PopServiceUserInfo({ children, onFinish }) {
  const [form] = Form.useForm();
  const [list, setList] = useState({ catCd: "", catNm: "", codeNm: "", devTp: "" });

  // [SVC-0105014006] 신청서비스별 디바이스 조회
  useEffect(() => {
    form.resetFields();
    const apiDeviceCall = async () => {
      const response = await apiGetPath(`Device/service/${children.catCd}`);
      try {
        if (response.code === 0) {
          setList(response.data);
        } else if (response.code === 10) {
          setList({ catCd: "", catNm: "", codeNm: "", devTp: "" });
        }
      } catch (error) {}
    };
    apiDeviceCall();
  }, [children]);

  const validatePhoneNumber = (validate, value) => {
    if (!/^01([0|1|6|7|8|9])-?([0-9]{4})-?([0-9]{4})$/.test(value)) {
      return Promise.reject(new Error(validate.message));
    } else {
      return Promise.resolve();
    }
  };

  const onChangeTelNum = (e) => {
    let value = e.target.value;
    if (/[^0-9]/g.test(value)) {
      return;
    } else {
      form.setFieldsValue({
        telNum: value.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3"),
      });
    }
  };

  const validateCompCorpNum = (validate, value) => {
    if (!/^([0-9]{3})-?([0-9]{2})-?([0-9]{5})$/.test(value)) {
      return Promise.reject(new Error(validate.message));
    } else {
      return Promise.resolve();
    }
  };

  const onChangeCompCorpNum = (e) => {
    let value = e.target.value;
    if (/[^0-9]/g.test(value)) {
      return;
    } else {
      form.setFieldsValue({
        compCorpNum: value.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3"),
      });
    }
  };

  const onChangeSiteCorpNum = (e) => {
    let value = e.target.value;
    if (/[^0-9]/g.test(value)) {
      return;
    } else {
      form.setFieldsValue({
        siteCorpNum: value.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3"),
      });
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...children,
      startDt: moment(children.startDt).format("YYYY-MM-DD"),
      endDt: moment(children.endDt).format("YYYY-MM-DD"),
      // siteCorpNum:""
    });
  }, [children]);

  return (
    <Styles>
      <Form name='basic' className='label-w-150' autoComplete='off' form={form} onFinish={onFinish} id='formInfo'>
        <Form.Item>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='고객사' name='compNm' rules={[{ ...requredRlues }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item
                label='고객사 사업자 등록번호'
                name='compCorpNum'
                // rules={[{...requredRlues}]}
                rules={[
                  {
                    required: true,
                    validator: validateCompCorpNum,
                    message: "올바른 사업자 등록번호 양식이 아닙니다.",
                  },
                ]}
              >
                {/*<InputNumber type={"number"} controls={false} style={{width : 344}} onChange={onChangeCompCorpNum} maxLength={12} />*/}
                <Input onChange={onChangeCompCorpNum} maxLength={12} />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='사업장' name='siteNm' rules={[{ ...requredRlues }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item label='사업장 사업자 등록번호' name='siteCorpNum'>
                <Input onChange={onChangeSiteCorpNum} maxLength={12} />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='주소' name='address' rules={[{ ...requredRlues }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item label='서비스 요청번호' name='svcReqId'>
                <Input disabled style={{ color: "#000000d9" }} />
                {/* {children.svcReqId} */}
                {/* <Statistic value={children.catNm} /> */}
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <hr />
        <Form.Item>
          <Col {...responsiveColOption}>
            <Form.Item label='담당자' name='userNm' rules={[{ ...requredRlues }]}>
              <Input maxLength={25} />
            </Form.Item>
          </Col>
        </Form.Item>
        <Form.Item>
          <Col {...responsiveColOption}>
            <Form.Item
              label='이메일'
              name='mail'
              rules={[{ type: "email", message: "올바른 email 양식이 아닙니다.", required: true }]}
            >
              <Input maxLength={20} disabled style={{ color: "#000000d9" }} />
            </Form.Item>
          </Col>
        </Form.Item>
        <Form.Item>
          <Col {...responsiveColOption}>
            <Form.Item
              label='연락처'
              name='telNum'
              // rules={[{...requredRlues}]}
              rules={[
                {
                  required: true,
                  validator: validatePhoneNumber,
                  message: "올바른 전화번호 양식이 아닙니다.",
                },
              ]}
            >
              <Input onChange={onChangeTelNum} maxLength={13} />
            </Form.Item>
          </Col>
        </Form.Item>
        <hr />
        <SectionTitleArea title='서비스 이용 정보' depth='none' />
        <Form.Item label='신청 서비스' name='catNm'>
          <Statistic value={children.catNm} />
        </Form.Item>
        <Form.Item label='디바이스 수량'>
          <Statistic
            value={`
            ${list.codeNm === undefined ? "" : list.codeNm} 
            ${children.devNum === undefined ? "0" : children.devNum}`}
            suffix='대'
          />
        </Form.Item>

        <Form.Item label='서비스 개시 요청일' name='startDt'>
          <Statistic value={children.startDt} />
        </Form.Item>
        <Form.Item label='구독기간(약정기간)' name='subPeriod'>
          <Statistic value={children.subPeriod} suffix='개월' />
        </Form.Item>
        <Form.Item label='서비스 만료일' name='endDt'>
          <Statistic value={children.endDt} />
        </Form.Item>
        <Form.Item label='월 구독료' name='subPay'>
          <Statistic value={children.subPay} suffix='원' />
        </Form.Item>
      </Form>
    </Styles>
  );
}

export default PopServiceUserInfo;
